<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="modal-header">
    <h3 class="modal-title font" *ngIf="newItem; else editTarifaTitle">Nueva notificación</h3>
    <ng-template #editTarifaTitle>
      <h3 class="modal-title font">Edición de notificación</h3>
    </ng-template>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

    <form class="form-search py-3" [formGroup]="formGroup">
      <div class="row-fields">
        <div class="field field-50">
          <label for="fechaDesde">Fecha desde <span class="oblig">*</span></label>

          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker" formControlName="fechaDesde">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fechaDesde', 'matDatepickerParse')">Formato incorrecto</mat-error>
              <mat-error *ngIf="controlHasError('fechaDesde', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="field field-50">
          <label for="fechaHasta">Fecha hasta <span class="oblig">*</span></label>

          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker2" formControlName="fechaHasta">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker2"></mat-datepicker-toggle>
              <mat-datepicker #datepicker2>
              </mat-datepicker>
              <mat-error *ngIf="controlHasError('fechaHasta', 'matDatepickerParse')">Formato incorrecto</mat-error>
              <mat-error *ngIf="controlHasError('fechaHasta', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row-fields">
        <div class="field field-100">
          <label for="rol">Roles <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="rol" id="rol" placeholder="-- Roles --" multiple>
                <mat-option *ngFor="let rol of roles" [value]="rol">
                  {{ rol.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="controlHasError('rol', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row-fields">
        <div class="field field-100">
          <label for="mensaje">Mensaje <span class="oblig">*</span></label>
          
            <mat-form-field appearance="outline" class="textarea-field">
                <textarea class="form-control" matInput formControlName="mensaje" id="mensaje"
                    placeholder="Mensaje" rows="4" ></textarea>
                <mat-error *ngIf="controlHasError('mensaje', 'required')">Campo
                    obligatorio</mat-error>
            </mat-form-field>
         
        </div>
      </div>
    </form>

  </div>
  <div class="modal-footer actions">
    <div class="note"><span *ngIf="editMode">* Campos Obligatorios</span></div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="guardar()"
        aria-label="Guardar">Guardar</button>
    </div>
  </div>
</div>
